//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('selectPortalUser', {
//        templateUrl: 'views/components/views/selectPortalUser/selectPortalUser.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'utilityService', 'selectPortalUserService', function ($stateParams, utilityService, selectPortalUserService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let custactNo = $stateParams.arg1;
            
//            vm.model = {
//                portalUserButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => reset('portal_user') },
//                    { id: 'search', icon: 'glyphicon glyphicon-search', color: 'success', type: 'success', onClick: () => loadPortalUsers() }
//                ],
//                setting: {
//                    portal_user: ''
//                },
//                itemsListPortalUsers: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadPortalUsers() {
//                if (utilityService.validateParmsValue(vm.model.setting.portal_user, true) !== true) return;

//                vm.model.itemsListPortalUsers = await selectPortalUserService.listPortalUsers({
//                    custact_no: custactNo,
//                    user_name: vm.model.setting.portal_user
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region RESET BUTTON FUNCTION

//            function reset(id) {
//                switch (id) {
//                    case 'portal_user':
//                        vm.model.setting.portal_user = '';

//                        if (vm.model.setting.portal_user === '') loadPortalUsers();
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion RESET BUTTON FUNCTION

//            // #region SEARCH FUNCTION

//            vm.searchPortalUser = function () {
//                loadPortalUsers();
//            };

//            // #endregion SEARCH FUNCTION

//            // #region SAVE & GO TO PREVIOUS

//            vm.goToPrevious = function (item) {
//                selectPortalUserService.saveItem({
//                    custact_no: custactNo,
//                    portal_user_keyno: item.item_id
//                });
//            };

//            // #endregion SAVE & GO TO PREVIOUS

//            // #region ON BLUR MULTI FUNCTIONS

//            vm.onBlur = function (id) {
//                switch (id) {
//                    case 'portal_user':
//                        if (utilityService.validateParmsValue(vm.model.setting.portal_user) !== true) return;

//                        if (vm.model.setting.portal_user > '') loadPortalUsers();
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion ON BLUR MULTI FUNCTIONS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'portal_user':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.portal_user) !== true) return;

//                        vm.model.setting.portal_user = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.portal_user, true) !== true) return;

//                        if (vm.model.setting.portal_user === '') loadPortalUsers();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                if (vm.model.setting.portal_user === '') loadPortalUsers();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
